import { environment } from '../../src/environments/environment.prod';

import { BrowserModule } from '@angular/platform-browser';
import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule, RouterOutlet } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';

declare var $: any;
declare var jQuery: any;

import { AppComponent } from './app.component';
import { HeadersComponent } from './headers/headers.component';
import { FootersComponent } from './footers/footers.component';
import { FooterComponent } from './footer/footer.component';
import { CalloutsComponent } from './callouts/callouts.component';
import { CalloutStyle1Component } from './callouts/callout-style1/callout-style1.component';
import { CustomersComponent } from './customers/customers.component';
import { CustomerStyle1Component } from './customers/customer-style1/customer-style1.component';
import { ApplinkStyle1Component } from './callouts/applink-style1/applink-style1.component';
import { FeaturesComponent } from './features/features.component';
import { FeatureStyle1Component } from './features/feature-style1/feature-style1.component';
import { ServicesComponent } from './services/services.component';
import { ServiceStyle1Component } from './services/service-style1/service-style1.component';
import { SlidersComponent } from './sliders/sliders.component';
import { SliderStyle1Component } from './sliders/slider-style1/slider-style1.component';
import { IconsComponent } from './icons/icons.component';
import { PaymentIconsComponent } from './icons/payment-icons/payment-icons.component';
import { MegaMenuComponent } from './mega-menu/mega-menu.component';
import { MenuStyle1Component } from './mega-menu/menu-style1/menu-style1.component';
import { MenuStyle2Component } from './mega-menu/menu-style2/menu-style2.component';
import { MenuStyle3Component } from './mega-menu/menu-style3/menu-style3.component';
import { MenuStyle4Component } from './mega-menu/menu-style4/menu-style4.component';
import { MenuStyle5Component } from './mega-menu/menu-style5/menu-style5.component';
import { MenuStyle6Component } from './mega-menu/menu-style6/menu-style6.component';

// Routes handler
import { routes } from './app.router';

import { HomeComponent } from './home/home.component';
import { TopBarComponent } from './headers/top-bar/top-bar.component';
import { ActionBarComponent } from './headers/action-bar/action-bar.component';
import { DataService } from '../Services/DataSharingService';
import { ShowCodeComponent } from './show-code/show-code.component';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { ColorService } from '../Services/ColorService';
import { UserTemplateComponent } from './user-template/user-template.component';
import { FooterService } from '../Services/FooterService';
import { FooterViewComponent } from './footers/footer-view/footer-view.component';
import { HeaderComponent } from './header/header.component';
import { HeaderService } from '../Services/HeaderService';
import { HeaderViewComponent } from './headers/header-view/header-view.component';
import { Title} from '@angular/platform-browser';
import { TemplateDesignerComponent } from './template-designer/template-designer.component';
import { TemplateViewComponent } from './template-designer/template-view/template-view.component';
import { TemplateService } from '../Services/TemplateService';
import { GettingStartedComponent } from './getting-started/getting-started.component';
import { PageLoadersComponent } from './page-loaders/page-loaders.component';
import { PreLoadersComponent } from './features/pre-loaders/pre-loaders.component';
import { ButtonsComponent } from './features/buttons/buttons.component';
import { BasicButtonsComponent } from './features/buttons/basic-buttons/basic-buttons.component';
import { IconButtonsComponent } from './features/buttons/icon-buttons/icon-buttons.component';
import { AnimatedButtonsComponent } from './features/buttons/animated-buttons/animated-buttons.component';
import { LabeledButtonsComponent } from './features/buttons/labeled-buttons/labeled-buttons.component';
import { ColoredLabelButtonsComponent } from './features/buttons/colored-label-buttons/colored-label-buttons.component';
import { LabelIconButtonsComponent } from './features/buttons/label-icon-buttons/label-icon-buttons.component';
import { ColoredButtonsComponent } from './features/buttons/colored-buttons/colored-buttons.component';
import { AlertButtonsComponent } from './features/buttons/alert-buttons/alert-buttons.component';
import { BasicColoredButtonsComponent } from './features/buttons/basic-colored-buttons/basic-colored-buttons.component';
import { OutlineColoredButtonsComponent } from './features/buttons/outline-colored-buttons/outline-colored-buttons.component';
import { FilledColoredButtonsComponent } from './features/buttons/filled-colored-buttons/filled-colored-buttons.component';
import { HorizontalGroupButtonsComponent } from './features/buttons/horizontal-group-buttons/horizontal-group-buttons.component';
import { VerticalGroupButtonsComponent } from './features/buttons/vertical-group-buttons/vertical-group-buttons.component';
import { IconGroupButtonsComponent } from './features/buttons/icon-group-buttons/icon-group-buttons.component';
import { LoadingButtonsComponent } from './features/buttons/loading-buttons/loading-buttons.component';
import { SocialButtonsComponent } from './features/buttons/social-buttons/social-buttons.component';
import { SizeButtonsComponent } from './features/buttons/size-buttons/size-buttons.component';
import { FloatedButtonsComponent } from './features/buttons/floated-buttons/floated-buttons.component';
import { ToggleButtonsComponent } from './features/buttons/toggle-buttons/toggle-buttons.component';
import { FluidButtonsComponent } from './features/buttons/fluid-buttons/fluid-buttons.component';
import { CircleButtonsComponent } from './features/buttons/circle-buttons/circle-buttons.component';
import { EqualWidthButtonsComponent } from './features/buttons/equal-width-buttons/equal-width-buttons.component';
import { GradientVerticalButtonsComponent } from './features/buttons/gradient-vertical-buttons/gradient-vertical-buttons.component';
import { GradientHorizontalButtonsComponent } from './features/buttons/gradient-horizontal-buttons/gradient-horizontal-buttons.component';
import { GradientDiagonalButtonsComponent } from './features/buttons/gradient-diagonal-buttons/gradient-diagonal-buttons.component';
import { FormElementComponent } from './features/form-element/form-element.component';
import { BasicInputComponent } from './features/form-element/basic-input/basic-input.component';
import { InputWithLoaderComponent } from './features/form-element/input-with-loader/input-with-loader.component';
import { InputWithIconComponent } from './features/form-element/input-with-icon/input-with-icon.component';
import { InputWithTextComponent } from './features/form-element/input-with-text/input-with-text.component';
import { InputWithDropdownComponent } from './features/form-element/input-with-dropdown/input-with-dropdown.component';
import { InputWithTagComponent } from './features/form-element/input-with-tag/input-with-tag.component';
import { InputWithButtonComponent } from './features/form-element/input-with-button/input-with-button.component';
import { MessageAlertComponent } from './features/message-alert/message-alert.component';
import { MessageAlertStyle1Component } from './features/message-alert/message-alert-style1/message-alert-style1.component';
import { MessageAlertStyle2Component } from './features/message-alert/message-alert-style2/message-alert-style2.component';
import { MessageAlertStyle3Component } from './features/message-alert/message-alert-style3/message-alert-style3.component';
import { MessageAlertStyle4Component } from './features/message-alert/message-alert-style4/message-alert-style4.component';
import { MessageAlertStyle5Component } from './features/message-alert/message-alert-style5/message-alert-style5.component';
import { MessageAlertStyle6Component } from './features/message-alert/message-alert-style6/message-alert-style6.component';
import { MessageAlertStyle7Component } from './features/message-alert/message-alert-style7/message-alert-style7.component';
import { MessageAlertStyle8Component } from './features/message-alert/message-alert-style8/message-alert-style8.component';
import { MessageAlertStyle9Component } from './features/message-alert/message-alert-style9/message-alert-style9.component';
import { TabinationComponent } from './features/tabination/tabination.component';
import { FullWidthPillComponent } from './features/tabination/full-width-pill/full-width-pill.component';
import { AnimationPillComponent } from './features/tabination/animation-pill/animation-pill.component';
import { NormalPillComponent } from './features/tabination/normal-pill/normal-pill.component';
import { VerticalPillComponent } from './features/tabination/vertical-pill/vertical-pill.component';
import { TabComponent } from './features/tabination/tab/tab.component';
import { TabGroupComponent } from './features/tabination/tab-group/tab-group.component';
import { PillGroupComponent } from './features/tabination/pill-group/pill-group.component';
import { InputSelComponent } from './features/form-element/input-sel/input-sel.component';
import { DividerComponent } from './features/divider/divider.component';
import { HrDividerComponent } from './features/divider/hr-divider/hr-divider.component';
import { HrDividerWithTextComponent } from './features/divider/hr-divider-with-text/hr-divider-with-text.component';
import { StepComponent } from './features/step/step.component';
import { Style1Component } from './features/step/style1/style1.component';
import { Style2Component } from './features/step/style2/style2.component';
import { Style3Component } from './features/step/style3/style3.component';
import { GridComponent } from './features/grid/grid.component';
import { FlexRowComponent } from './features/grid/flex-row/flex-row.component';
import { FlexColumnComponent } from './features/grid/flex-column/flex-column.component';
import { FlexJustifyContentComponent } from './features/grid/flex-justify-content/flex-justify-content.component';
import { FlexAlignItemComponent } from './features/grid/flex-align-item/flex-align-item.component';
import { FlexAlignSelfComponent } from './features/grid/flex-align-self/flex-align-self.component';
import { FlexColumnAndItemComponent } from './features/grid/flex-column-and-item/flex-column-and-item.component';
import { FlexRowAndItemComponent } from './features/grid/flex-row-and-item/flex-row-and-item.component';
import { FlexWrapAndContentComponent } from './features/grid/flex-wrap-and-content/flex-wrap-and-content.component';
import { BtnEffectComponent } from './features/buttons/btn-effect/btn-effect.component';
import { BtnAddonComponent } from './features/buttons/btn-addon/btn-addon.component';
import { TypographyComponent } from './features/typography/typography.component';
import { HeadingComponent } from './features/typography/heading/heading.component';
import { TitleWithBorderComponent } from './features/typography/title-with-border/title-with-border.component';
import { MultiBorderTitleComponent } from './features/typography/multi-border-title/multi-border-title.component';
import { ListStyleRoundComponent } from './features/typography/list-style-round/list-style-round.component';
import { ListStyleRoundOutlineComponent } from './features/typography/list-style-round-outline/list-style-round-outline.component';
import { ListStyleSquareComponent } from './features/typography/list-style-square/list-style-square.component';
import { ListStyleSquareOutlineComponent } from './features/typography/list-style-square-outline/list-style-square-outline.component';
import { ListStyleCounterComponent } from './features/typography/list-style-counter/list-style-counter.component';
import { ListStyleCounterOutlineComponent } from './features/typography/list-style-counter-outline/list-style-counter-outline.component';
import { BlockquoteComponent } from './features/typography/blockquote/blockquote.component';
import { BlockquoteWithFooterComponent } from './features/typography/blockquote-with-footer/blockquote-with-footer.component';
import { TextTranformComponent } from './features/typography/text-tranform/text-tranform.component';
import { TableResponsiveComponent } from './features/typography/table-responsive/table-responsive.component';
import { TableScrollDesktop160Component } from './features/typography/table-scroll-desktop-160/table-scroll-desktop-160.component';
import { TableScrollDesktopComponent } from './features/typography/table-scroll-desktop/table-scroll-desktop.component';
import { TableWithColorsComponent } from './features/typography/table-with-colors/table-with-colors.component';
import { TableResponsive2Component } from './features/typography/table-responsive-2/table-responsive-2.component';
import { TableWithoutBorderComponent } from './features/typography/table-without-border/table-without-border.component';
import { TooltipComponent } from './features/typography/tooltip/tooltip.component';
import { PaginationButtonComponent } from './features/buttons/pagination-button/pagination-button.component';
import { FlagComponent } from './features/flag/flag.component';
import { RibbonComponent } from './features/ribbon/ribbon.component';
import { RibbonStyle1Component } from './features/ribbon/ribbon-style-1/ribbon-style-1.component';
import { RibbonStyle2Component } from './features/ribbon/ribbon-style-2/ribbon-style-2.component';
import { RibbonStyle3Component } from './features/ribbon/ribbon-style-3/ribbon-style-3.component';
import { TagsComponent } from './features/ribbon/tags/tags.component';
import { LabelInputComponent } from './features/form-element/label-input/label-input.component';
import { AccordianComponent } from './features/accordian/accordian.component';
import { AccordianStyle1Component } from './features/accordian/accordian-style1/accordian-style1.component';
import { AccordianStyle2Component } from './features/accordian/accordian-style2/accordian-style2.component';
import { AccordianStyle3Component } from './features/accordian/accordian-style3/accordian-style3.component';
import { AccordianStyle4Component } from './features/accordian/accordian-style4/accordian-style4.component';
import { PreLoaderStylesComponent } from './features/pre-loaders/pre-loader-styles/pre-loader-styles.component';
import { PrettyCheckComponent } from './features/pretty-check/pretty-check.component';
import { BasicCheckboxDefaultComponent } from './features/pretty-check/basic-checkbox-default/basic-checkbox-default.component';
import { SwitchCheckboxComponent } from './features/pretty-check/switch-checkbox/switch-checkbox.component';
import { ColorCheckboxSolidComponent } from './features/pretty-check/color-checkbox-solid/color-checkbox-solid.component';
import { ColorCheckboxOutlineComponent } from './features/pretty-check/color-checkbox-outline/color-checkbox-outline.component';
import { ColorCheckboxSwitchComponent } from './features/pretty-check/color-checkbox-switch/color-checkbox-switch.component';
import { IconicCheckboxComponent } from './features/pretty-check/iconic-checkbox/iconic-checkbox.component';
import { ToggleCheckboxComponent } from './features/pretty-check/toggle-checkbox/toggle-checkbox.component';
import { BasicRadioDefaultComponent } from './features/pretty-check/basic-radio-default/basic-radio-default.component';
import { ColorRadioOutlineComponent } from './features/pretty-check/color-radio-outline/color-radio-outline.component';
import { FillRadioWithIconComponent } from './features/pretty-check/fill-radio-with-icon/fill-radio-with-icon.component';
import { ColorRadioSolidComponent } from './features/pretty-check/color-radio-solid/color-radio-solid.component';
import { PlainRadioComponent } from './features/pretty-check/plain-radio/plain-radio.component';
import { SwitchRadioComponent } from './features/pretty-check/switch-radio/switch-radio.component';
import { HeadersStylesComponent } from './features/headers-styles/headers-styles.component';
import { HeaderStyle1Component } from './features/headers-styles/header-style1/header-style1.component';
import { HeaderStyle2Component } from './features/headers-styles/header-style2/header-style2.component';
import { HeaderStyle3Component } from './features/headers-styles/header-style3/header-style3.component';
import { HeaderStyle4Component } from './features/headers-styles/header-style4/header-style4.component';
import { HeaderStyle5Component } from './features/headers-styles/header-style5/header-style5.component';
import { ButtonInsetBorderComponent } from './features/buttons/button-inset-border/button-inset-border.component';
import { ButtonInsetOutlineBorderComponent } from './features/buttons/button-inset-outline-border/button-inset-outline-border.component';
import { SkewButtonComponent } from './features/buttons/skew-button/skew-button.component';
import { SkewOutlineButtonComponent } from './features/buttons/skew-outline-button/skew-outline-button.component';
import { BtnHoverStylesComponent } from './features/buttons/btn-hover-styles/btn-hover-styles.component';
import { AccordianStyle5Component } from './features/accordian/accordian-style5/accordian-style5.component';
import { AccordianStyle6Component } from './features/accordian/accordian-style6/accordian-style6.component';
import { AccordianStyle7Component } from './features/accordian/accordian-style7/accordian-style7.component';
import { AccordianStyle8Component } from './features/accordian/accordian-style8/accordian-style8.component';
import { MessageAlertStyle10Component } from './features/message-alert/message-alert-style10/message-alert-style10.component';
import { MessageAlertStyle11Component } from './features/message-alert/message-alert-style11/message-alert-style11.component';
import { BadgeComponent } from './features/badge/badge.component';
import { BadgeWithNotifComponent } from './features/badge/badge-with-notif/badge-with-notif.component';
import { CornerBadgeComponent } from './features/badge/corner-badge/corner-badge.component';
import { ImageBadgeComponent } from './features/badge/image-badge/image-badge.component';
import { StandardBadgeComponent } from './features/badge/standard-badge/standard-badge.component';
import { CardsComponent } from './features/cards/cards.component';
import { CardsStyle1Component } from './features/cards/cards-style1/cards-style1.component';
import { CardsStyle3Component } from './features/cards/cards-style3/cards-style3.component';
import { CardsStyle4Component } from './features/cards/cards-style4/cards-style4.component';
import { CardsStyle5Component } from './features/cards/cards-style5/cards-style5.component';
import { CardsStyle6Component } from './features/cards/cards-style6/cards-style6.component';
import { CardsStyle7Component } from './features/cards/cards-style7/cards-style7.component';
import { CardsStyle8Component } from './features/cards/cards-style8/cards-style8.component';
import { FlipCardComponent } from './features/cards/flip-card/flip-card.component';
import { CardsStyle9Component } from './features/cards/cards-style9/cards-style9.component';
import { TestimonialComponent } from './features/testimonial/testimonial.component';
import { TestimonialStyle1Component } from './features/testimonial/testimonial-style1/testimonial-style1.component';
import { TestimonialStyle2Component } from './features/testimonial/testimonial-style2/testimonial-style2.component';
import { TestimonialStyle3Component } from './features/testimonial/testimonial-style3/testimonial-style3.component';
import { TestimonialStyle4Component } from './features/testimonial/testimonial-style4/testimonial-style4.component';
import { TestimonialStyle5Component } from './features/testimonial/testimonial-style5/testimonial-style5.component';
import { TestimonialStyle6Component } from './features/testimonial/testimonial-style6/testimonial-style6.component';
import { IconComponent } from './features/icon/icon.component';
import { BreadcrumbComponent } from './features/typography/breadcrumb/breadcrumb.component';
import { TableDoubleScrollComponent } from './features/typography/table-double-scroll/table-double-scroll.component';
import { RowAndColumnComponent } from './features/grid/row-and-column/row-and-column.component';
import { FlexColumnReverseAndWrapComponent } from './features/grid/flex-column-reverse-and-wrap/flex-column-reverse-and-wrap.component';
import { FlexRowReverseAndWrapComponent } from './features/grid/flex-row-reverse-and-wrap/flex-row-reverse-and-wrap.component';
import { FlexNowrapComponent } from './features/grid/flex-nowrap/flex-nowrap.component';
import { FlexWrapComponent } from './features/grid/flex-wrap/flex-wrap.component';
import { LightSliderComponent } from './features/light-slider/light-slider.component';
import { Slider1Component } from './features/light-slider/slider1/slider1.component';
import { Slider2Component } from './features/light-slider/slider2/slider2.component';
import { Slider3Component } from './features/light-slider/slider3/slider3.component';
import { CardsStyle10Component } from './features/cards/cards-style10/cards-style10.component';
import { CardsStyle11Component } from './features/cards/cards-style11/cards-style11.component';
import { PillStyle1Component } from './features/tabination/pill-style1/pill-style1.component';
import { PillStyle2Component } from './features/tabination/pill-style2/pill-style2.component';
import { PillStyle3Component } from './features/tabination/pill-style3/pill-style3.component';
import { PillStyle4Component } from './features/tabination/pill-style4/pill-style4.component';
import { VerticalPillStyle1Component } from './features/tabination/vertical-pill-style1/vertical-pill-style1.component';
import { TabStyle1Component } from './features/tabination/tab-style1/tab-style1.component';
import { CustomLoader1Component } from './features/pre-loaders/custom-loader-1/custom-loader-1.component';
import { CustomLoader2Component } from './features/pre-loaders/custom-loader-2/custom-loader-2.component';
import { CustomLoader3Component } from './features/pre-loaders/custom-loader-3/custom-loader-3.component';
import { ProgressBarComponent } from './features/pre-loaders/progress-bar/progress-bar.component';
import { QuatityStyle1Component } from './features/form-element/quatity-style1/quatity-style1.component';
import { InputGroupComponent } from './features/form-element/input-group/input-group.component';
import { BoxModelComponent } from './features/box-model/box-model.component';
import { ValidationLengthComponent } from './features/form-element/validation-length/validation-length.component';
import { FormComponent } from './features/form/form.component';
import { Form1Component } from './features/form/form1/form1.component';
import { Form2Component } from './features/form/form2/form2.component';
import { InputStateComponent } from './features/form-element/input-state/input-state.component';
import { PopupComponent } from './features/popup/popup.component';
import { PopupStylesComponent } from './features/popup/popup-styles/popup-styles.component';
import { Style4Component } from './features/step/style4/style4.component';
import { Style5Component } from './features/step/style5/style5.component';
import { Style6Component } from './features/step/style6/style6.component';
import { Style7Component } from './features/step/style7/style7.component';
import { SliderStyle2Component } from './sliders/slider-style2/slider-style2.component';
import { WowSliderComponent } from './features/wow-slider/wow-slider.component';
import { WowSlideDownComponent } from './features/wow-slider/wow-slide-down/wow-slide-down.component';
import { WowSlideInLeftComponent } from './features/wow-slider/wow-slide-in-left/wow-slide-in-left.component';
import { WowSlideInRightComponent } from './features/wow-slider/wow-slide-in-right/wow-slide-in-right.component';
import { WowSlideInUpComponent } from './features/wow-slider/wow-slide-in-up/wow-slide-in-up.component';
import { WowFadeInComponent } from './features/wow-slider/wow-fade-in/wow-fade-in.component';
import { WowFadeInDownComponent } from './features/wow-slider/wow-fade-in-down/wow-fade-in-down.component';
import { WowFadeInBigDownComponent } from './features/wow-slider/wow-fade-in-big-down/wow-fade-in-big-down.component';
import { WowFadeInLeftComponent } from './features/wow-slider/wow-fade-in-left/wow-fade-in-left.component';
import { WowFadeInLeftBigComponent } from './features/wow-slider/wow-fade-in-left-big/wow-fade-in-left-big.component';
import { WowFadeInRightComponent } from './features/wow-slider/wow-fade-in-right/wow-fade-in-right.component';
import { WowFadeInRightBigComponent } from './features/wow-slider/wow-fade-in-right-big/wow-fade-in-right-big.component';
import { WowFadeInUpComponent } from './features/wow-slider/wow-fade-in-up/wow-fade-in-up.component';
import { WowFadeInUpBigComponent } from './features/wow-slider/wow-fade-in-up-big/wow-fade-in-up-big.component';
import { WowBounceComponent } from './features/wow-slider/wow-bounce/wow-bounce.component';
import { WowBounceInDownComponent } from './features/wow-slider/wow-bounce-in-down/wow-bounce-in-down.component';
import { WowBounceInLeftComponent } from './features/wow-slider/wow-bounce-in-left/wow-bounce-in-left.component';
import { WowBounceInRightComponent } from './features/wow-slider/wow-bounce-in-right/wow-bounce-in-right.component';
import { WowBounceInUpComponent } from './features/wow-slider/wow-bounce-in-up/wow-bounce-in-up.component';
import { UikitCdnComponent } from './features/uikit-cdn/uikit-cdn.component';
import { ContentNavComponent } from './features/contentNav/contentNav.component';
import { EcommerceHeaderStyle1Component } from './features/headers-styles/ecommerce-header-style1/ecommerce-header-style1.component';
import { EcommerceHeaderStyle2Component } from './features/headers-styles/ecommerce-header-style2/ecommerce-header-style2.component';
import { EcommerceHeaderStyle3Component } from './features/headers-styles/ecommerce-header-style3/ecommerce-header-style3.component';
import { EcommerceHeaderStyle4Component } from './features/headers-styles/ecommerce-header-style4/ecommerce-header-style4.component';
import { EcommerceHeaderStyle5Component } from './features/headers-styles/ecommerce-header-style5/ecommerce-header-style5.component';
import { EcommerceHeaderStyle6Component } from './features/headers-styles/ecommerce-header-style6/ecommerce-header-style6.component';
import { EcommerceHeaderStyle7Component } from './features/headers-styles/ecommerce-header-style7/ecommerce-header-style7.component';
import { FancyBoxComponent } from './features/fancy-box/fancy-box.component';
import { SampleFancyImageGalleryComponent } from './features/fancy-box/sample-fancy-image-gallery/sample-fancy-image-gallery.component';
import { FancyBoxEffectComponent } from './features/fancy-box/fancy-box-effect/fancy-box-effect.component';
import { FancyBoxButtonComponent } from './features/fancy-box/fancy-box-button/fancy-box-button.component';
import { FancyBoxThumbnailComponent } from './features/fancy-box/fancy-box-thumbnail/fancy-box-thumbnail.component';
import { FancyBoxWithTextComponent } from './features/fancy-box/fancy-box-with-text/fancy-box-with-text.component';

@NgModule({
    declarations: [
        AppComponent,
        HeadersComponent,
        FootersComponent,
        FooterComponent,
        CalloutsComponent,
        CalloutStyle1Component,
        CustomersComponent,
        CustomerStyle1Component,
        ApplinkStyle1Component,
        FeatureStyle1Component,
        ServicesComponent,
        ServiceStyle1Component,
        SlidersComponent,
        SliderStyle1Component,
        IconsComponent,
        PaymentIconsComponent,
        MegaMenuComponent,
        MenuStyle1Component,
        MenuStyle2Component,
        MenuStyle3Component,
        MenuStyle4Component,
        MenuStyle5Component,
        MenuStyle6Component,
        HomeComponent,
        TopBarComponent,
        ActionBarComponent,
        ShowCodeComponent,
        UserTemplateComponent,
        FooterViewComponent,
        HeaderComponent,
        HeaderViewComponent,
        TemplateDesignerComponent,
        TemplateViewComponent,
        GettingStartedComponent,
        FeaturesComponent,
        PageLoadersComponent,
        PreLoadersComponent,
        ButtonsComponent,
        BasicButtonsComponent,
        IconButtonsComponent,
        AnimatedButtonsComponent,
        LabeledButtonsComponent,
        ColoredLabelButtonsComponent,
        LabelIconButtonsComponent,
        ColoredButtonsComponent,
        AlertButtonsComponent,
        BasicColoredButtonsComponent,
        OutlineColoredButtonsComponent,
        FilledColoredButtonsComponent,
        HorizontalGroupButtonsComponent,
        VerticalGroupButtonsComponent,
        IconGroupButtonsComponent,
        LoadingButtonsComponent,
        SocialButtonsComponent,
        SizeButtonsComponent,
        FloatedButtonsComponent,
        ToggleButtonsComponent,
        FluidButtonsComponent,
        CircleButtonsComponent,
        EqualWidthButtonsComponent,
        GradientVerticalButtonsComponent,
        GradientHorizontalButtonsComponent,
        GradientDiagonalButtonsComponent,
        FormElementComponent,
        BasicInputComponent,
        InputWithLoaderComponent,
        InputWithIconComponent,
        InputWithTextComponent,
        InputWithDropdownComponent,
        InputWithTagComponent,
        InputWithButtonComponent,
        MessageAlertComponent,
        MessageAlertStyle1Component,
        MessageAlertStyle2Component,
        MessageAlertStyle3Component,
        MessageAlertStyle4Component,
        MessageAlertStyle5Component,
        MessageAlertStyle6Component,
        MessageAlertStyle7Component,
        MessageAlertStyle8Component,
        MessageAlertStyle9Component,
        TabinationComponent,
        FullWidthPillComponent,
        AnimationPillComponent,
        NormalPillComponent,
        VerticalPillComponent,
        TabComponent,
        TabGroupComponent,
        PillGroupComponent,
        InputSelComponent,
        DividerComponent,
        HrDividerComponent,
        HrDividerWithTextComponent,
        StepComponent,
        Style1Component,
        Style2Component,
        Style3Component,
        GridComponent,
        FlexRowComponent,
        FlexColumnComponent,
        FlexJustifyContentComponent,
        FlexAlignItemComponent,
        FlexAlignSelfComponent,
        FlexColumnAndItemComponent,
        FlexRowAndItemComponent,
        FlexWrapAndContentComponent,
        BtnEffectComponent,
        BtnAddonComponent,
        TypographyComponent,
        HeadingComponent,
        TitleWithBorderComponent,
        MultiBorderTitleComponent,
        ListStyleRoundComponent,
        ListStyleRoundOutlineComponent,
        ListStyleSquareComponent,
        ListStyleSquareOutlineComponent,
        ListStyleCounterComponent,
        ListStyleCounterOutlineComponent,
        BlockquoteComponent,
        BlockquoteWithFooterComponent,
        TextTranformComponent,
        TableResponsiveComponent,
        TableScrollDesktop160Component,
        TableScrollDesktopComponent,
        TableWithColorsComponent,
        TableResponsive2Component,
        TableWithoutBorderComponent,
        TooltipComponent,
        PaginationButtonComponent,
        FlagComponent,
        RibbonComponent,
        RibbonStyle1Component,
        RibbonStyle2Component,
        RibbonStyle3Component,
        TagsComponent,
        LabelInputComponent,
        AccordianComponent,
        AccordianStyle1Component,
        AccordianStyle2Component,
        AccordianStyle3Component,
        AccordianStyle4Component,
        PreLoaderStylesComponent,
        PrettyCheckComponent,
        BasicCheckboxDefaultComponent,
        SwitchCheckboxComponent,
        ColorCheckboxSolidComponent,
        ColorCheckboxOutlineComponent,
        ColorCheckboxSwitchComponent,
        IconicCheckboxComponent,
        ToggleCheckboxComponent,
        BasicRadioDefaultComponent,
        ColorRadioOutlineComponent,
        FillRadioWithIconComponent,
        ColorRadioSolidComponent,
        PlainRadioComponent,
        SwitchRadioComponent,
        HeadersStylesComponent,
        HeaderStyle1Component,
        HeaderStyle2Component,
        HeaderStyle3Component,
        HeaderStyle4Component,
        HeaderStyle5Component,
        ButtonInsetBorderComponent,
        ButtonInsetOutlineBorderComponent,
        SkewButtonComponent,
        SkewOutlineButtonComponent,
        BtnHoverStylesComponent,
        AccordianStyle5Component,
        AccordianStyle6Component,
        AccordianStyle7Component,
        AccordianStyle8Component,
        MessageAlertStyle10Component,
        MessageAlertStyle11Component,
        BadgeComponent,
        BadgeWithNotifComponent,
        CornerBadgeComponent,
        ImageBadgeComponent,
        StandardBadgeComponent,
        CardsComponent,
        CardsStyle1Component,
        CardsStyle3Component,
        CardsStyle4Component,
        CardsStyle5Component,
        CardsStyle6Component,
        CardsStyle7Component,
        CardsStyle8Component,
        FlipCardComponent,
        CardsStyle9Component,
        TestimonialComponent,
        TestimonialStyle1Component,
        TestimonialStyle2Component,
        TestimonialStyle3Component,
        TestimonialStyle4Component,
        TestimonialStyle5Component,
        TestimonialStyle6Component,
        IconComponent,
        BreadcrumbComponent,
        TableDoubleScrollComponent,
        RowAndColumnComponent,
        FlexColumnReverseAndWrapComponent,
        FlexRowReverseAndWrapComponent,
        FlexNowrapComponent,
        FlexWrapComponent,
        LightSliderComponent,
        Slider1Component,
        Slider2Component,
        Slider3Component,
        CardsStyle10Component,
        CardsStyle11Component,
        PillStyle1Component,
        PillStyle2Component,
        PillStyle3Component,
        PillStyle4Component,
        VerticalPillStyle1Component,
        TabStyle1Component,
        CustomLoader1Component,
        CustomLoader2Component,
        CustomLoader3Component,
        ProgressBarComponent,
        QuatityStyle1Component,
        InputGroupComponent,
        BoxModelComponent,
        ValidationLengthComponent,
        FormComponent,
        Form1Component,
        Form2Component,
        InputStateComponent,
        PopupComponent,
        PopupStylesComponent,
        Style4Component,
        Style5Component,
        Style6Component,
        Style7Component,
        SliderStyle2Component,
        WowSliderComponent,
        WowSlideDownComponent,
        WowSlideInLeftComponent,
        WowSlideInRightComponent,
        WowSlideInUpComponent,
        WowFadeInComponent,
        WowFadeInDownComponent,
        WowFadeInBigDownComponent,
        WowFadeInLeftComponent,
        WowFadeInLeftBigComponent,
        WowFadeInRightComponent,
        WowFadeInRightBigComponent,
        WowFadeInUpComponent,
        WowFadeInUpBigComponent,
        WowBounceComponent,
        WowBounceInDownComponent,
        WowBounceInLeftComponent,
        WowBounceInRightComponent,
        WowBounceInUpComponent,
        UikitCdnComponent,
        ContentNavComponent,
        EcommerceHeaderStyle1Component,
        EcommerceHeaderStyle2Component,
        EcommerceHeaderStyle3Component,
        EcommerceHeaderStyle4Component,
        EcommerceHeaderStyle5Component,
        EcommerceHeaderStyle6Component,
        EcommerceHeaderStyle7Component,
        FancyBoxComponent,
        SampleFancyImageGalleryComponent,
        FancyBoxEffectComponent,
        FancyBoxButtonComponent,
        FancyBoxThumbnailComponent,
        FancyBoxWithTextComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        routes,
        NgMultiSelectDropDownModule.forRoot(),
        MonacoEditorModule.forRoot()
    ],
    providers: [
		{
			provide: LocationStrategy,
      useClass: PathLocationStrategy,
		},
        DataService,
        ColorService,
        FooterService,
        HeaderService,
        TemplateService,
        Title
    ],
    bootstrap: [
        AppComponent
    ]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts